/**
 * Application configuration and constants
 */

// Time constants
export const MILLISECONDS_PER_SECOND = 1000;
export const SECONDS_PER_MINUTE = 60;
export const MINUTES_PER_HOUR = 60;
export const MILLISECONDS_PER_MINUTE = MILLISECONDS_PER_SECOND * SECONDS_PER_MINUTE;
export const MILLISECONDS_PER_HOUR = MILLISECONDS_PER_MINUTE * MINUTES_PER_HOUR;

// Refresh intervals for various data sources
export const REFRESH_INTERVALS = {
  RADAR: 10 * MILLISECONDS_PER_MINUTE,
  WARNINGS: 5 * MILLISECONDS_PER_MINUTE,
  LIGHTNING: 1 * MILLISECONDS_PER_MINUTE,
  WEATHER: 30 * MILLISECONDS_PER_SECOND,
  TASK: 1 * MILLISECONDS_PER_SECOND,
  FORECAST: 60 * MILLISECONDS_PER_MINUTE,
  SENSORS: 1 * MILLISECONDS_PER_MINUTE,
  CHORE: 30 * MILLISECONDS_PER_SECOND,
  RECORDS: 30 * MILLISECONDS_PER_MINUTE,
  APPLIANCES: 1 * MILLISECONDS_PER_MINUTE,
  VACUUMS: 30 * MILLISECONDS_PER_SECOND,
};

// Chore-related constants
export const CHORE_URGENT_THRESHOLD_MINUTES = 10;
export const CHORE_REFRESH_DELAY_MS = 500;

// Confetti animation constants
export const CONFETTI_DURATION_MS = 3000;
export const CONFETTI_PARTICLE_COUNT = 150;
export const CONFETTI_SIDE_PARTICLE_COUNT = 5;

// API endpoints
export const API_BASE = '/internal';
export const API_ENDPOINTS = {
  CONFIG: `${API_BASE}/config`,
  CSRF_TOKEN: `${API_BASE}/csrf-token`,
  CHORE: `${API_BASE}/chore`,
  CHORE_COMPLETE: `${API_BASE}/chore/complete`,
  CHORE_UNCOMPLETE: `${API_BASE}/chore/uncomplete`,
  RADAR: `${API_BASE}/radar`,
  SENSORS: `${API_BASE}/govee-current`,
  APPLIANCES: `${API_BASE}/appliances-current`,
  WARNINGS: `${API_BASE}/warnings`,
  FORECAST: `${API_BASE}/forecast`,
  FORECAST_DATA: `${API_BASE}/forecast-data`,
  degradation: `${API_BASE}/degradation`,
  TEMPEST_STATS: `${API_BASE}/tempest-stats`,
  WIND_ROSE: `${API_BASE}/tempest-windrose`,
};

// WebSocket configuration
export const WS_URL = 'wss://ws.weatherflow.com/swd/data';
